__turbopack_context__.v({
  "d-flex": "yc-deal-module-scss-module__-msTVq__d-flex",
  "nav-wrapper": "yc-deal-module-scss-module__-msTVq__nav-wrapper",
  "top-nav": "yc-deal-module-scss-module__-msTVq__top-nav",
  "yc-deal": "yc-deal-module-scss-module__-msTVq__yc-deal",
  "yc-hero-section": "yc-deal-module-scss-module__-msTVq__yc-hero-section",
});
